'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



/*****************
 ** WEBPACK FOOTER
 ** ./~/json-schema-ref-parser/~/js-yaml/index.js
 ** module id = 135
 ** module chunks = 0
 **/